<template>
  <div>
    <show-table
      ref="ShowTable"
      @addClick="AddClick"
      @editClick="EditClick"
      @setTkIndexUrl="SetTkIndexUrl"
    ></show-table>
    <a-modal
      v-model:open="EditModelVisible"
      :title="amodelTitle"
      :width="amodelWidth"
      :wrap-class-name="amodelHeight"
    >
      <template #footer></template>
      <show-edit
        :keyMod="selKeywordMod"
        @EditComHandle="EditComHandle"
      ></show-edit>
    </a-modal>

    <a-modal
      v-model:open="SetModelVisible"
      :title="smodelTitle"
      width="90%"
      :wrap-class-name="amodelHeight"
    >
      <set-index-url ref="SetTkIndexUrl" @EditComHandle="IndexUrlComHandle"></set-index-url>
      <template #footer></template>
    </a-modal>
  </div>
</template>

<script>
import { ShowTable, ShowEdit, SetIndexUrl } from "./components/index.js";
export default {
  components: {
    ShowTable,
    ShowEdit,
    SetIndexUrl,
  },
  data() {
    return {
      isMobile: false,
      EditModelVisible: false,
      SetModelVisible: false,
      amodelTitle: "",
      smodelTitle: "设置抖音首页链接",
      selKeywordMod: {
        id: "",
        keyWord: "",
        state: true,
      },
    };
  },
  created() {
    this.checkIfMobile();
  },
  computed: {
    amodelHeight() {
      return this.isMobile ? "full-modal" : "helf-modal";
    },
    amodelWidth() {
      return this.isMobile ? "100%" : "50%";
    },
  },
  methods: {
    AddClick() {
      this.amodelTitle = "词汇添加";
      this.selKeywordMod = {
        id: "",
        keyword: "",
        wciKeyWord: "",
        tkKeyWord: "",
        state: true,
      };
      this.EditModelVisible = true;
    },
    EditClick(row) {
      this.amodelTitle = "词汇编辑";
      this.selKeywordMod = {
        id: row.id,
        keyWord: row.keyWord,
        wciKeyWord: row.wciKeyWord,
        tkKeyWord: row.tkKeyWord,
        state: row.state,
      };
      this.EditModelVisible = true;
    },
    EditComHandle() {
      this.EditModelVisible = false;
      this.$refs.ShowTable.GetTableData();
    },
    checkIfMobile() {
      // 通常以768px作为移动设备的断点
      this.isMobile = window.innerWidth <= 768;
    },
    SetTkIndexUrl(id) {
      console.log(id);
      this.SetModelVisible = true;
      this.$nextTick(() => {
        this.$refs.SetTkIndexUrl.GetKeyDefaultUrls(id);
      });
    },
    IndexUrlComHandle() {
      this.SetModelVisible = false;
    }
  },
};
</script>

<style lang="scss" scoped>
</style>